export const getConversation = (conversationId, successCallback, onError) => {
  fetch(`/api/v1/conversations/${conversationId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (response.ok) return response.json();
      return response.json().then((errorData) => Promise.reject(errorData));
    })
    .then((data) => successCallback(data))
    .catch((data) => onError(data));
};

export const getConversations = (successCallback, page = 1, onError = () => {}) => {
  return fetch(`/api/v1/conversations?page=${page}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data.conversations, data.meta);
    })
    .catch(onError);
};

export const createComplianceAcknowledgment = (conversationId, successCallback, onError) => {
  fetch(`/api/v1/conversations/${conversationId}/compliance_acknowledgment`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (response.ok) return response.json();
      return response.json().then((errorData) => Promise.reject(errorData));
    })
    .then((data) => successCallback(data))
    .catch((error) => {
      if (onError) onError(error);
    });
};

export const createConversation = (params, successCallback, onError) => {
  fetch(`/api/v1/conversations`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (response.ok) return response.json();
      return response.json().then((errorData) => Promise.reject(errorData));
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      if (onError) {
        onError(error);
      }
    });
};

export const translateConversation = (conversationId, params, successCallback, onError) => {
  fetch(`/api/v1/conversations/${conversationId}/translate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (response.ok) return response.json();
      return response.json().then((errorData) => Promise.reject(errorData));
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      if (onError) {
        onError(error);
      }
    });
};
